export default "__VITE_ASSET__Cb33FYzh__"